import { get } from 'svelte/store';
import { format } from 'svelte-i18n';
//Types
import type { ActionJob, LocalControlOptions } from 'src/types/requests/schedules/schedules_g2';

export const getMediaPlayerLocalActions = (
	action: ActionJob,
	localControlOptions: LocalControlOptions[],
): LocalControlOptions[] => {
	const $format = get(format);
	const mediaAttr = {
		attr: {
			volume: action.params?.volume >= 0,
		},
		params: {
			volume: action.params?.volume ?? undefined,
		},
	};
	localControlOptions = [
		{
			...mediaAttr,
			title: $format('label_media_play', {
				default: 'Play media',
			}),
			value: 'media.mediaplayer.play',
		},
		{
			...mediaAttr,
			title: $format('label_media_pause', {
				default: 'Pause media',
			}),
			value: 'media.mediaplayer.pause',
		},
		{
			...mediaAttr,
			title: $format('label_media_stop', {
				default: 'Stop media',
			}),
			value: 'media.mediaplayer.stop',
		},
		{
			attr: {
				volume: action.params?.volume >= 0,
			},
			params: {
				id: action.params.id ?? undefined,
				volume: action.params?.volume ?? undefined,
			},
			title: $format('scene_action_mp_play', {
				default: 'Select song to play',
			}),
			value: 'media.mediaplayer.playaudioclip',
		},
		{
			...mediaAttr,
			title: $format('scene_action_radio_play_favourite', {
				default: 'Play media from radio',
			}),
			value: 'media.radio.playfavourite',
		},
	];
	return localControlOptions;
};
